module.exports = __webpack_public_path__ + "1P-Icons.9b9a82531fe39e7327ff.eot";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/images/fonts/1P-Icons.eot
// module id = ../../../../../src/assets/images/fonts/1P-Icons.eot
// module chunks = styles